import {handleUpdate} from './common'

export default function groups(state = {}, action) {
  return handleUpdate('groups',state,action)
}


/** WEBPACK FOOTER **
 ** ./src/app/reducers/groups.js
 **/